module.exports = __webpack_public_path__ + "static/media/10.bb9c6e08.jpg";